import clsx from "clsx";
import {useIntl} from "react-intl";
import IKeyValue from "../core/interfaces/IKeyValue.ts";
import {ulid} from "ulid";

export interface IComponent {
  fieldsProps: any;
  i18n: string;
  options: IKeyValue[],
  error?: string;
  value?: string;
  touched?: boolean;
  hideLabel?: boolean;
  selectLabel?: string;
  disabled?: boolean;
  inputGroup?: any[];
}

export default function (props: IComponent) {
  const intl = useIntl()

  return <>
    {!props.hideLabel &&
      <label className="fs-6 fw-semibold mb-2">{intl.formatMessage({id: props.i18n})}</label>
    }

    <div className={'input-group'}>
      {props.inputGroup?.map((input) => (
        <span key={ulid()} className={'input-group-text border-0'}>{input}</span>
      ))}

      <select
        {...props.fieldsProps}
        placeholder={intl.formatMessage({id: props.i18n})}
        disabled={props.disabled}
        className={'form-control form-control-solid'}
      >
        <option key={ulid()} selected={!props.value} value={''}>{props.selectLabel || intl.formatMessage({id: 'PLACEHOLDERS.SELECT'})}</option>
        {props.options.map((option) => (
          <option key={option.key} value={option.key}>{option.value}</option>
        ))
        }
      </select>
    </div>

    {(props.touched && props.error) && (
      <div className='fv-plugins-message-container'>
        <div className='fv-help-block'>
          <span role='alert'>{props.error}</span>
        </div>
      </div>
    )}
  </>
}
